import { c as _c } from "react/compiler-runtime";
import React from "react";
import style from "../../../shared/components/Spinner/Spinner.module.scss";
import elements from "./ActivityIndicator.module.scss";
export const ActivityIndicator: React.FC<{
  active: boolean;
}> = t0 => {
  const $ = _c(3);
  const {
    active
  } = t0;
  const t1 = elements["activity-indicator-wrapper"] + " " + (active ? elements["activity-indicator-wrapper--active"] : "");
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={style["lds-dual-ring"]} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <div className={t1}>{t2}</div>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};